import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/home_logo.png';
const _withScopeId = n => (_pushScopeId("data-v-441da3d7"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "nav-wrapper"
};
const _hoisted_2 = {
  class: "logo"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "divider"
}, null, -1));
const _hoisted_5 = {
  class: "route-title"
};
const _hoisted_6 = {
  class: "user-img"
};
const _hoisted_7 = /*#__PURE__*/_createTextVNode("退出");
const _hoisted_8 = {
  class: "content"
};
const _hoisted_9 = {
  class: "icon"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "font"
}, "您确定要退出登录吗?", -1));
const _hoisted_11 = /*#__PURE__*/_createTextVNode("取消");
const _hoisted_12 = /*#__PURE__*/_createTextVNode("确定");
import defaultSetting from '@/settings/defaultSetting';
import { WarningFilled } from '@element-plus/icons-vue';
import { ref } from 'vue';
import { useUserStore } from '@/store/module/user';
import { useRouter } from 'vue-router';
import Storage from '@/utils/storage';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const userStore = useUserStore();
    const Router = useRouter();
    const loading = ref(false);
    const visiable = ref(false);
    function confirmLogout() {
      loading.value = true;
      userStore.logout();
      Router.push({
        path: '/user/login'
      });
      Storage.clear();
      loading.value = false;
    }
    function logout() {
      visiable.value = true;
    }
    function cancle() {
      visiable.value = false;
    }
    return (_ctx, _cache) => {
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(defaultSetting).TITLE), 1)]), _createVNode(_component_el_dropdown, {
        placement: "bottom",
        "popper-class": "user-popver"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
            onClick: logout
          }, {
            default: _withCtx(() => [_hoisted_7]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_SvgIcon, {
          icon: "user",
          size: 30
        })])]),
        _: 1
      })]), _createVNode(_component_el_dialog, {
        modelValue: visiable.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => visiable.value = $event),
        width: 477,
        top: "100px",
        "destroy-on-close": "",
        "show-close": false,
        "close-on-click-modal": false,
        class: "logout-dialog",
        "close-on-press-escape": false,
        onClose: cancle
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          class: "cancle-btn",
          onClick: cancle
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: loading.value,
          class: "btn",
          type: "primary",
          onClick: confirmLogout
        }, {
          default: _withCtx(() => [_hoisted_12]),
          _: 1
        }, 8, ["loading"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_icon, {
          size: 20,
          style: {
            "vertical-align": "middle"
          },
          color: "red"
        }, {
          default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
          _: 1
        })]), _hoisted_10])]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});